import React, { Component } from 'react';
import { AppointmentRequirementsView } from './AppointmentRequirementsView';
import * as Constants from './constants';
import { hasRequirement } from './helpers';

/**
 * @param {Object[]} requirements
 * @returns {JSX.Element}
 * @constructor
 */
export class AppointmentRequirementsContainer extends Component {
    componentDidMount() {
        this.props.validationChange(this.props.isValid);

        if (
            hasRequirement(
                Constants.ADDRESS_CONFIRMATION,
                this.props.requirements
            )
        ) {
            this.props.trackShowRequiredAddressField();
        }
    }

    componentDidUpdate(prevProps) {
        const { validationChange } = prevProps;

        if (
            !hasRequirement(
                Constants.ADDRESS_CONFIRMATION,
                this.props.requirements
            ) &&
            hasRequirement(
                Constants.ADDRESS_CONFIRMATION,
                this.props.requirements
            )
        ) {
            this.props.trackShowRequiredAddressField();
        }

        if (
            prevProps.requirements.length !== 0 &&
            this.props.requirements.length === 0
        ) {
            validationChange(true);
        } else if (prevProps.isValid !== this.props.isValid) {
            validationChange(this.props.isValid);
        }
    }

    render() {
        const { requirements, ...otherProps } = this.props;
        return (
            <AppointmentRequirementsView
                requirements={requirements}
                requiresAddress={hasRequirement(
                    Constants.ADDRESS_CONFIRMATION,
                    requirements
                )}
                requiresAgeWarningConfirmation={hasRequirement(
                    Constants.AGE_WARNING,
                    requirements
                )}
                requiresObgynConfirmation={hasRequirement(
                    Constants.OBGYN_WARNING,
                    requirements
                )}
                requiresPrimaryCareConfirmation={hasRequirement(
                    Constants.PRIMARY_CARE_WARNING,
                    requirements
                )}
                requiresReferral={hasRequirement(
                    Constants.REFERRAL_REQUIRED,
                    requirements
                )}
                {...otherProps}
            />
        );
    }
}
